"use client";

import { Button } from '@/components/ui/button';
import { Users, RefreshCw, ArrowLeft } from 'lucide-react';

export default function ArtistError({ reset }: { error: Error; reset: () => void }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] px-4 text-center gap-5">
      <div className="h-14 w-14 rounded-full bg-muted flex items-center justify-center">
        <Users className="h-7 w-7 text-muted-foreground" />
      </div>
      <div className="space-y-1.5">
        <h2 className="text-xl font-semibold">Couldn&apos;t load artist page</h2>
        <p className="text-sm text-muted-foreground">This artist profile may have moved or there was a connection issue.</p>
      </div>
      <div className="flex gap-3">
        <Button onClick={reset} size="sm" className="gap-2">
          <RefreshCw className="h-3.5 w-3.5" />Try again
        </Button>
        <Button onClick={() => window.location.href = '/artists'} size="sm" variant="outline" className="gap-2">
          <ArrowLeft className="h-3.5 w-3.5" />All artists
        </Button>
      </div>
    </div>
  );
}
